import React from 'react'
import { MenuItem, MenuList, Typography } from '@material-ui/core'

import MoreVertMenu from 'app/componentV4/Menu/MoreVertMenu'
import { FormattedMessage, useIntl } from 'react-intl'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import {
  ListPenIcon,
  ListAddIcon,
  DeleteOutlinedIcon,
} from 'app/components/icons'

function GroupAction({
  isAdmin,
  group,
  onOpenDeleteGroupDialog,
  openEditNameGroupDialog,
  openAddSubgroupDialog,
}) {
  const { formatMessage } = useIntl()

  return (
    <>
      <MoreVertMenu icon="more_vert">
        {(closeMenu) => (
          <MenuList className="w-full">
            {isAdmin && (
              <MenuItem
                onClick={() => {
                  openEditNameGroupDialog(group)
                  closeMenu()
                }}
                className="space-x-4"
              >
                <ListPenIcon classes="w-24" />
                <Typography className="text-14 font-400 capitalize text-blue-950">
                  {formatMessage({
                    id: 'text.edit.name',
                  })}
                </Typography>
              </MenuItem>
            )}

            {isAdmin && (
              <MenuItem
                onClick={() => {
                  openAddSubgroupDialog(group)
                  closeMenu()
                }}
                className="space-x-4"
              >
                <ListAddIcon classes="w-24" />
                <Typography className="text-14 font-400 text-blue-950">
                  <FormattedMessage id="group.details.dialogs.addSubgroup" />
                </Typography>
              </MenuItem>
            )}

            {isAdmin && (
              <MenuItem
                onClick={() => {
                  onOpenDeleteGroupDialog([group.id], 'menu')
                  closeMenu()
                }}
                className="space-x-4"
              >
                <DeleteOutlinedIcon classes="w-24" />
                <Typography className="text-14 font-400 text-red-500">
                  {formatMessage({
                    id: 'action.delete',
                  })}
                </Typography>
              </MenuItem>
            )}
          </MenuList>
        )}
      </MoreVertMenu>
    </>
  )
}

export default GroupAction
